// extracted by mini-css-extract-plugin
export default {"container":"style_container__-Ao0d","tab":"style_tab__n2IFb","tabName":"style_tabName__mPqJN","active":"style_active__99OL1"};